// @mui material components
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import { Box, Typography, Paper } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { postDiger } from 'services/api/form';
import { parseStringNumber } from 'helpers/smallCodes';
import { config } from 'Constants';
import { styled } from '@mui/material/styles';

const HoverableBox = styled(MDBox)(({ theme }) => ({
    cursor: 'pointer',
    '&:hover': {
        opacity: 0.8,
        boxShadow: theme.shadows[4],
    },
}));

const saveSelection = (
    baslik,
    ekNot,
    verilenFiyat,
    miktar,
    lock,
    setLock,
    templateImage,
    demandID,
    queryClient,
    handleClose
) => {
    setLock(!lock);

    const values = {
        baslik: baslik,
        gorsel: templateImage,
        ekNot: ekNot,
        miktar: parseStringNumber(miktar),
        yoneticiNotu: 'OTO SHEET',
        verilenFiyat: parseStringNumber(
            verilenFiyat.replace('₺', '').replace('$', '').replace('€', '').replace('£', '')
        ),
        durumu: config?.demandStatusID?.fiyatVerildi,
    };

    postDiger(demandID, values)
        .then(() => {
            queryClient.invalidateQueries({ queryKey: ['fetchDemand', demandID] });
            handleClose();
        })
        .catch((err) => console.log(err));
};

function PriceCard({
    color,
    icon,
    baslik,
    ekNot,
    verilenFiyat,
    valueColor,
    miktar,
    lock,
    setLock,
    templateImage,
    demandID,
    queryClient,
    handleClose,
}) {
    // Fiyat bilgisini formatla
    const formattedPrice = verilenFiyat || '-';
    const isSelected = lock;

    return (
        <Paper
            elevation={0}
            sx={[
                {
                    height: '100%',
                    borderRadius: '8px',
                    border: '1px solid',
                    opacity: lock && !isSelected ? 0.6 : 1,
                    pointerEvents: lock && !isSelected ? 'none' : 'auto',
                    cursor: lock && !isSelected ? 'not-allowed' : 'pointer',
                    overflow: 'hidden',
                    position: 'relative',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'white',
                    '&:hover':
                        !lock || isSelected
                            ? {
                                  borderColor: '#3ECF8E',
                                  transform: 'translateY(-2px)',
                                  boxShadow: '0 2px 8px rgba(62, 207, 142, 0.1)',
                              }
                            : {},
                },
                isSelected
                    ? {
                          borderColor: '#3ECF8E',
                      }
                    : {
                          borderColor: '#EEEEEE',
                      },
            ]}
            onClick={() =>
                saveSelection(
                    ekNot,
                    baslik,
                    verilenFiyat,
                    miktar,
                    lock,
                    setLock,
                    templateImage,
                    demandID,
                    queryClient,
                    handleClose
                )
            }
        >
            {/* Seçili durumda gösterilecek işaret */}
            {isSelected && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        zIndex: 2,
                        color: '#3ECF8E',
                    }}
                >
                    <CheckCircleOutlineIcon />
                </Box>
            )}
            {/* Yeşil üst çizgi */}
            <Box
                sx={{
                    height: '4px',
                    width: '100%',
                    backgroundColor: '#3ECF8E',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
            />
            <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 600,
                        color: '#1E293B',
                        mb: 1.5,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '100%',
                    }}
                >
                    {baslik}
                </Typography>

                {ekNot && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#64748B',
                            mb: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            fontSize: '0.825rem',
                            lineHeight: 1.5,
                        }}
                    >
                        {ekNot}
                    </Typography>
                )}

                <Box sx={{ mt: 'auto', pt: 1.5 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: '#3ECF8E',
                            fontSize: '1.25rem',
                        }}
                    >
                        {formattedPrice}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
}

export default PriceCard;
